const MODEL_NAME = 'order'
export default [
  {
    path: `/${MODEL_NAME}/paySuccess`,
    name: 'paySuccess',
    component: () =>
      import(/* webpackChunkName: "order-paySuccess" */ '@pages/order/paySuccess/index.vue')
  }
]
